export default `
## Education

**University of Washington, Seattle — BS in Informatics**

_September 2013 - June 2017_

* Focus: Web Development & Data Science
* Teaching Assistant — Client-Side, Server-Side, Web Development
* Director of IT — Informatics Undergraduate Association

---
`;
